import {BlackTopCard} from '../widgets/black-top-card';

export const DropdownChoices = (props) => {
  if (!props?.show) {
    return <></>;
  }
  return (
    <div className={'slideInDown'}>
      <BlackTopCard header={props?.header} checked={props?.checked}>
        <label htmlFor={props?.name}>{props?.qs}?</label>
        <select
          style={{border: '1px solid silver'}} // Added inline style for silver border
          className={
            'form-select bg-white w-full active:border-0 active:outline-0 h-[34px] md:h-[2.6rem] outline-0 text-lg autofill:bg-transparent'
          }
          name={props?.name}
          id={props?.name}
          value={props?.value}
          onChange={(e) => {
            props.onChange(e.target.value);
          }}>
          {props.options.map((e, i) => (
            <option key={i} disabled={e?.disabled} selected={e?.selected} value={e?.value}>
              {e?.label}
            </option>
          ))}
        </select>
        {/* {formErrors.durationType && <div className="form-text text-danger ps-0">{formErrors.durationType}</div>} */}
      </BlackTopCard>
    </div>
  );
};
